import React, { useState } from "react";

const NoteSection = () => {
  const [notes] = useState([
    {
      id: 1,
      date: "2024-11-10",
      title: "Introduction to Computer Science",
      pdf: "/path/to/first-note.pdf",
    },
    {
      id: 2,
      date: "2024-11-12",
      title: "Data Structures - Arrays",
      pdf: "/path/to/second-note.pdf",
    },
    {
      id: 3,
      date: "2024-11-15",
      title: "Advanced Algorithms - Sorting",
      pdf: "/path/to/third-note.pdf",
    },
  ]);

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col  items-center p-12">
      <div className="max-w-6xl w-full  border-4 border-teal-500 rounded-lg p-4">
        <h2 className="text-3xl font-bold text-teal-500 mb-6 text-center">
          Student Notes
        </h2>

        {/* Responsive Table Wrapper */}
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white border border-gray-300 rounded-lg shadow-md">
            <thead className="bg-teal-500 text-white">
              <tr>
                <th className="px-4 py-3 text-left">S.No.</th>
                <th className="px-4 py-3 text-left">Date</th>
                <th className="px-4 py-3 text-left">Title</th>
                <th className="px-4 py-3 text-left">PDF</th>
              </tr>
            </thead>
            <tbody>
              {notes.map((note) => (
                <tr key={note.id} className="border-b hover:bg-gray-100">
                  <td className="px-4 py-4">{note.id}</td>
                  <td className="px-4 py-4">{note.date}</td>
                  <td className="px-4 py-4">{note.title}</td>
                  <td className="px-4 py-4">
                    <div className="flex gap-4">
                      {/* View Button */}
                      <a
                        href={note.pdf}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-teal-500 font-semibold hover:text-teal-700 hover:underline"
                      >
                        View
                      </a>
                      {/* Download Button */}
                      <a
                        href={note.pdf}
                        download
                        className="text-teal-500 font-semibold hover:text-teal-700 hover:underline"
                      >
                        Download
                      </a>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default NoteSection;
